import { render, staticRenderFns } from "./foodSchedule.vue?vue&type=template&id=6b1d4e00&scoped=true"
import script from "./foodSchedule.vue?vue&type=script&lang=js"
export * from "./foodSchedule.vue?vue&type=script&lang=js"
import style0 from "./foodSchedule.vue?vue&type=style&index=0&id=6b1d4e00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1d4e00",
  null
  
)

export default component.exports